import { InventoryItem } from '@app/utils/interfaces/inventory-item.interface';
import { getMatchScore } from '../get-match-score/get-match-score';

export function sortInventoryItemsByNameOrUpcScore(items: InventoryItem[], query: string) {
  const isUpcSearch = Number.isSafeInteger(Number(query));

  return items.sort((a, b) => {
    const aValue = isUpcSearch ? a.productUpc : a.productName;
    const bValue = isUpcSearch ? b.productUpc : b.productName;

    const aScore = getMatchScore(aValue.toString(), query);
    const bScore = getMatchScore(bValue.toString(), query);

    return aScore - bScore;
  });
}
